<template>
    <div class="modal hide fade in" id="modalReferencia" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Documento(s) de Referencia</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="col-12 padding">
                <div class="row">
                    <div class="form-group col-12">
                        <div id="Referencia_table" class="table-reponsive">
                          <table class="table table-striped table-light table-hover">
                            <thead class="thead-dark">
                              <tr>
                                <th>Área</th>
                                <th>Documento</th>
                                <th>Consecutivo</th>
                                <th>Referencia</th>
                                <th>Registró</th>
                                <th>Fecha</th>
                              </tr>
                            </thead>
                            <tbody class="text-dark">
                              <tr v-if="ListaReferencia.length <= 0">
                                <td colspan="12" class="text-center">No hay registro del Volumen</td>
                              </tr>
                             <tr v-else v-for="detalle in ListaReferencia" :key="detalle.DocumentoInventarioReferenciaId">
                                <td>{{detalle.Referencia.Area.Alias}}</td>
                                <td>{{detalle.Referencia.TipoDocumento.Nombre}}</td>
                                <td>{{detalle.Referencia.Anio}}/{{detalle.Referencia.Consecutivo}}</td>
                                <td>{{detalle.TipoReferencia.Nombre}}</td>
                                <td>{{detalle.UsuarioQueRegistro.Nombre}} {{detalle.UsuarioQueRegistro.ApellidoPaterno}} {{detalle.UsuarioQueRegistro.ApellidoMaterno}}</td>
                                <td v-html="obtenFechaConFormato(detalle.FechaRegistro)" style="width: 100px;"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-dark" id="botonAceptar" data-dismiss="modal">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'

export default {
    data(){
      return{
        ListaReferencia: []
        }
    },
    props:{
        DatosReferencia: Array
    },
    methods: {
        Mostrar: function () {
        $('#modalReferencia').modal('show');
        $('#closeModal').unbind('click').click(this.ModalClose);
        $('#botonAceptar').unbind('click').click(this.ModalClose);
        },
        ModalClose: function(){
          $('#modalReferencia').modal('hide');
          this.$emit('dialogo', false);
        },
        obtenFechaConFormato: function(fechaRegistro) {
        return moment(fechaRegistro).format("DD-MM-YYYY");
        }
    },
    mounted(){
        this.Mostrar();
        this.ListaReferencia = this.DatosReferencia;
    }
}
</script>
<style scoped>
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none;
    overflow: hidden;
    outline: 0;
  }

  input[type="text"]:read-only {
    background: #504f54;
  }

    input[type="text"]:read-only:focus {
      color: #fff;
    }
    .modal-content {
      background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/ReferenciaModal.vue